/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactNode } from "react";

import { ICON_DEFAULT_STYLE } from "@/shared/constants/strings";
import { CSSInterpolation, CSSProperties } from "@mui/material/styles";

import { InfoIcon } from "@dotnet/telematics-design-system";

import Tooltip from "../../Tooltip/Tooltip";
import { useStyles } from "../styles";

interface InfoIconWithTooltipProps {
  title: string | ReactNode;
  customIconStyle?: CSSInterpolation;
  iconTestId?: string;
  tooltipMinWidth?: string;
  placement?: "top" | "bottom" | "left" | "right";
  tooltipSize?: "small" | "medium";
  iconStyle?: CSSProperties;
}

const InfoIconWithTooltip = ({
  title,
  customIconStyle,
  iconTestId,
  tooltipMinWidth,
  placement,
  tooltipSize = "medium",
  iconStyle
}: InfoIconWithTooltipProps) => {
  const { infoIcon } = useStyles();

  return (
    <Tooltip
      title={title}
      size={tooltipSize}
      placement={placement || "top"}
      hasArrow
      minWidth={tooltipMinWidth}
    >
      <span css={css(customIconStyle as TemplateStringsArray)}>
        <InfoIcon
          style={iconStyle ?? ICON_DEFAULT_STYLE}
          data-testid={iconTestId || "info-icon-with-tooltip"}
          css={css(infoIcon)}
        />
      </span>
    </Tooltip>
  );
};

export default InfoIconWithTooltip;
